import _ from 'lodash'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import isBrowser from 'utils/isBrowser'
import * as classifiedActions from 'reduxBits/classified/actions'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'
import { adData, motorAdData, globalData } from 'tracking/dataCollectors'
import pi from 'utils/productIntegration'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    ...gtm.clearDataLayerParameters(),
    ...globalData(state),
    ...{
      event: 'view', // trigger GTM tags
      eventType: 'View', // Begin with uppercase. Type of action for pulse.
      objectType: 'ClassifiedAd', // Begin with uppercase
      domain: 'adout', // Technical domain. Ex. adout
      subDomain: 'view', // Technical sub domain. Ex. list.
      objectId: `${_.get(state, 'classified.requestedAd.ad.listId', undefined)}`,
      objectName: `${_.get(state, 'classified.requestedAd.ad.subject', undefined)}`,
      objectProductIntegrations: pi(
        _.get(state, 'classified.requestedAd.ad.featuredPlacements', []),
      ),
      ...adData(_.get(state, 'classified.requestedAd.ad', {})),
      objectCustom: {
        ...motorAdData(_.get(state, 'classified.requestedAd.ad', {})),
      },
      origin: {
        id: `${_.get(state, 'classified.requestedAd.ad.listId', undefined)}`,
        type: 'ClassifiedAd',
        url: encodeURI(window.location.href),
        name: `${_.get(state, 'classified.requestedAd.ad.subject', undefined)}`,
        category: ' ',
      },
    },
    ...localData,
  })

export const viewAdDefault = {
  validators: [
    validators.redux(
      '@@router/LOCATION_CHANGE',
      (action) =>
        _.get(action, 'payload.location.pathname', '').startsWith('/annons/') && isBrowser(),
    ),
    validators.redux(classifiedActions.RECEIVE_AD),
  ],
  events: [gtm.event(({ state }) => createDataLayerObject(state, {}))],
}

export const viewAdNoUpdate = {
  validators: [
    validators.redux('@@router/LOCATION_CHANGE', (action) =>
      _.get(action, 'payload.location.pathname', '').startsWith('/annons/'),
    ),
    validators.redux(classifiedActions.NO_UPDATE, (action) => action.payload === 'fetchAd'),
  ],
  events: [gtm.event(({ state }) => createDataLayerObject(state, {}))],
}
